import { ConnectedAccountStatus } from '@40seas/entities/connected-accounts';
import { EnumColor } from '@40seas/frontend/common/providers';

export const connectedAccountsStatusMapping = {
    [ConnectedAccountStatus.Active]: 'success',
    [ConnectedAccountStatus.ActionRequired]: 'warning',
    [ConnectedAccountStatus.Initiated]: 'info',
    [ConnectedAccountStatus.Pending]: 'info',
    [ConnectedAccountStatus.Submitted]: 'secondary',
    [ConnectedAccountStatus.Suspended]: 'error',
    [ConnectedAccountStatus.Disabled]: 'warning',
} as { [key in ConnectedAccountStatus]: EnumColor };
